import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const DualLine = styled.h2`
  text-align: ${props => props.align || 'center'};
  margin: ${props => props.margin || '0 0 20px 0'};
  font-family: var(--font, sans-serif);
  font-size: ${props => props.fontSize || '32px'};
  font-weight: ${props => props.fontWeight || '700'};
  line-height: 1.2;
`;

const PartOne = styled.span`
  color: ${props => props.color || 'var(--text-primary)'};
  margin-right: ${props => props.spacing || '8px'};
`;

const PartTwo = styled.span`
  color: ${props => props.color || 'var(--accent)'};
  background: ${props => props.gradient ? `linear-gradient(135deg, ${props.color || 'var(--accent)'}, var(--accent-neon))` : 'none'};
  -webkit-background-clip: ${props => props.gradient ? 'text' : 'border-box'};
  -webkit-text-fill-color: ${props => props.gradient ? 'transparent' : 'inherit'};
`;

const DualColorHeadlineWidget = ({ node }) => {
  const text1 = node.content?.text1 || 'Innovatives';
  const text2 = node.content?.text2 || 'Design System';
  
  const align = node.style?.desktop?.align || 'center';
  const fontSize = node.style?.desktop?.fontSize || '36px';
  const color1 = node.style?.desktop?.color1 || '';
  const color2 = node.style?.desktop?.color2 || '';
  const useGradient = node.style?.desktop?.useGradient !== false;

  return (
    <DualLine align={align} fontSize={fontSize}>
      <PartOne color={color1}>{text1}</PartOne>
      <PartTwo color={color2} gradient={useGradient}>{text2}</PartTwo>
    </DualLine>
  );
};

registry.register('dual_headline', {
  label: 'Dual Headline',
  icon: '🆎',
  category: 'advanced',
  defaultContent: {
    text1: 'Innovatives',
    text2: 'Design System'
  },
  defaultStyle: {
    desktop: {
      align: 'center',
      fontSize: '42px',
      useGradient: true
    }
  },
  render: DualColorHeadlineWidget,
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Texte',
          fields: [
            { name: 'content.text1', label: 'Teil 1 (Normal)', type: 'text' },
            { name: 'content.text2', label: 'Teil 2 (Hervorgehoben)', type: 'text' }
          ]
        }
      ]
    },
    {
      tab: 'style',
      groups: [
        {
          title: 'Farben & Effekte',
          fields: [
            { name: 'style.desktop.color1', label: 'Farbe Teil 1 (CSS / Hex)', type: 'text' },
            { name: 'style.desktop.color2', label: 'Farbe Teil 2 (CSS / Hex)', type: 'text' },
            { name: 'style.desktop.useGradient', label: 'Teil 2 als Verlauf', type: 'select', options: [{label:'Ja', value:true}, {label:'Nein', value:false}] }
          ]
        },
        {
          title: 'Typografie',
          fields: [
            { name: 'style.desktop.fontSize', label: 'Schriftgröße (px/em/rem)', type: 'text' },
            { name: 'style.desktop.align', label: 'Ausrichtung', type: 'select', options: [{label:'Links', value:'left'}, {label:'Zentriert', value:'center'}, {label:'Rechts', value:'right'}] }
          ]
        }
      ]
    }
  ]
});
